import { put, call, takeLatest, select } from 'redux-saga/effects'
import startOfDay from 'date-fns/startOfDay'
import subWeeks from 'date-fns/subWeeks'

import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getProfileViews } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchProfileViews() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getProfileViews, id, { start_at: subWeeks(startOfDay(new Date()), 8) })
    yield put(hiringAnalyticsView.fetchProfileViewsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchProfileViewsError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchProfileViewsSaga() {
  yield takeLatest(hiringAnalyticsView.FETCH_PROFILE_VIEWS, fetchProfileViews)
}
